<template>
    <TestReports/>
</template>

<script>
import TestReports from '@/components/TestReports';
export default {
    components: { TestReports },

}
</script>

<style>

</style>